import React, { useEffect, useState, useRef } from 'react';
import Handlebars from 'handlebars/dist/cjs/handlebars';
import { Tile, TileHeader, TileTitle, TileSubtitle, Button } from 'cantarus-react-ui';
import { registerHandlebarsHelpers } from '../../utils/handlebarsHelpers';
import { LivePreviewStrings as Strings } from '../../utils/config';
import * as templateApi from '../../api/templateApi';
import Spinner from '../common/Spinner';
import TemplatePreviewPopUp from '../PopUp/TemplatePreviewPopUp';
import ScalablePreview from '../ScalablePreview/ScalablePreview';
import RefreshIcon from '../../../assets/images/cc_icon_refresh.svg';
import PreviewIcon from '../../../assets/images/cc_icon_preview.svg';
import './styles.css';

const LivePreview = ({ previewData, templateId }) => {

    const [loading, setLoading] = useState(true);
    const [templateContent, setTemplateContent] = useState('')
    const [compiledTemplate, setCompiledTemplate] = useState(null)
    const [templateWithData, setTemplateWithData] = useState(Strings.noPreviewData)
    const [showPopUp, setShowPopUp] = useState(false);
    const [previewToggle, _setPreviewToggle] = useState(false);

    // Ref used to toggle the preview by event listener
    const previewToggleRef = useRef(previewToggle)

    // Ref needs to be updated along with the state
    const setPreviewToggle = value => {
        previewToggleRef.current = value;
        _setPreviewToggle(value);
    }

    const setLivePreview = () => {
        if (compiledTemplate && previewData) {
            const template = compiledTemplate.compileTemplateFunction({ models: previewData })
            setTemplateWithData(template);
        }
        else {
            setTemplateWithData(Strings.noPreviewData);
        }
    }

    const fetchTemplate = async () => {
        if (templateId !== 0) {
            const template = await templateApi.getTemplateById(templateId);
            setTemplateContent(template ? template.Content : '');
        }
    }

    const togglePopUp = () => {
        setShowPopUp(!showPopUp);
        setPreviewToggle(!previewToggle);
    }

    // Add admin panel collapse listener on element mount
    useEffect(() => {
        function updatePreview() {
            setPreviewToggle(!previewToggleRef.current)
        }

        document.querySelector('.can-ui-admin-panel__toggle').addEventListener('click', updatePreview);
        return () => {
            document.querySelector('.can-ui-admin-panel__toggle').removeEventListener('click', updatePreview);
        };
    }, [])

    useEffect(() => {
        setLoading(true);
        setTimeout(() => setLoading(false), 750);
        fetchTemplate();
    }, [templateId])

    useEffect(() => {
        registerHandlebarsHelpers();
        const envelopedTemplate = envelopTemplate(templateContent);
        const template = Handlebars.compile(envelopedTemplate);
        setCompiledTemplate({ compileTemplateFunction: template });
    }, [templateContent])

    useEffect(() => {
       setLivePreview();
    }, [compiledTemplate, previewData])

    return (
        <Tile classes={['live-preview']}>
            <TileHeader>
                <TileTitle>{Strings.header}</TileTitle>
                <TileSubtitle>
                    <div className="td-live-preview-controls">
                        <Button icon={RefreshIcon} title={Strings.refreshPreview} onClick={() => { setPreviewToggle(!previewToggle) }} />
                        <Button icon={PreviewIcon} title={Strings.expandPreview} onClick={togglePopUp} />
                    </div>
                </TileSubtitle>
            </TileHeader>
            {
                loading ?
                    <Spinner />
                    : <div
                        className="td-live-preview"
                    >
                        <ScalablePreview htmlToDisplay={templateWithData} toggleRefresh={previewToggle} />
                        <TemplatePreviewPopUp
                            show={showPopUp}
                            compiledTemplate={templateWithData}
                            togglePopUp={togglePopUp}
                        />
                    </div>
            }
        </Tile>
    );
}

export default LivePreview;

function envelopTemplate(template) {
    return "{{#each models}}" + template + "{{/each}}"
}
